import React from 'react';
import { WHATSAPP, INSTAGRAM } from '../data/contacto';
import MarcoMarca from './MarcoMarca';

// La página de Antonela, en la estética de la marca 2026 y en su voz (primera persona, frases cortas).
// 🟠 Para confirmar con An antes de publicar: la línea de Mercado Libre, el Instagram de las charlas (hoy @somosguia.ai) y la foto nueva (public/anto.jpg es la anterior).
const LIBRO = 'https://labs.guia-ai.com.ar/punto-asterisco/';

const EnlaceBoton = ({ href, children, externo }) => (
  <a href={href} className="guia-btn" {...(externo ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
    <svg className="guia-btn__arc guia-btn__arc--l" viewBox="0 0 16 52" aria-hidden="true"><path d="M 14 0 C -2 14 -2 38 14 52" /></svg>
    <span>{children}</span>
    <svg className="guia-btn__arc guia-btn__arc--r" viewBox="0 0 16 52" aria-hidden="true"><path d="M 2 0 C 18 14 18 38 2 52" /></svg>
  </a>
);

const HACER = [
  { titulo: 'Charlas', texto: 'Hablo de IA con ejemplos reales y sin tecnicismos. Las anuncio en Instagram.', enlace: { href: `https://instagram.com/${INSTAGRAM}`, texto: `@${INSTAGRAM}`, externo: true } },
  { titulo: 'Capacitaciones', texto: 'Cuatro semanas, en grupos chicos, con tu caso sobre la mesa. Hay un encuentro gratuito de 45 minutos para ver si te conviene.', enlace: { href: '/', texto: 'Quiero capacitarme' } },
  { titulo: 'Consultoría', texto: 'Miro cómo trabajás hoy y recién después decidimos qué automatizar.', enlace: { href: '/', texto: 'Contame tu caso' } },
];

const PersonalLanding = () => (
  <MarcoMarca pantalla="antonela">
    <div className="gp-pagina">
      <section className="gh-panel gp-hero" data-theme="claro" aria-labelledby="gp-titular">
        <img
          src="/anto.jpg" alt="Antonela Dutruel" className="gp-foto" width="96" height="96"
          onError={e => { e.currentTarget.style.display = 'none'; }}
        />
        <p className="gp-nombre">Antonela Dutruel</p>
        <h1 id="gp-titular" className="gp-titular">Veo lo invisible. Lo convierto en sistemas.</h1>
        <p className="gp-lead">Soy consultora, educadora y estratega de IA. Trabajo desde Córdoba.</p>
      </section>

      <section className="gh-panel gp-bloque" data-fase="charla" aria-labelledby="gp-hago">
        <h2 id="gp-hago" className="gp-h2">Lo que hago</h2>
        <ul className="gp-lista">
          {HACER.map(h => (
            <li key={h.titulo}>
              <h3 className="gp-h3">{h.titulo}</h3>
              <p>{h.texto}</p>
              <a href={h.enlace.href} className="gp-enlace" {...(h.enlace.externo ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>{h.enlace.texto} →</a>
            </li>
          ))}
        </ul>
      </section>

      <section className="gh-panel gp-bloque" data-fase="charla" aria-labelledby="gp-pienso">
        <h2 id="gp-pienso" className="gp-h2">Cómo pienso</h2>
        <blockquote className="gp-cita">Que la tecnología sirva, no solo que funcione.</blockquote>
        <p>Vengo de programar: cuatro años desarrollando software en Mercado Libre. Por eso ordeno antes de automatizar. La IA que me interesa ayuda a pensar, y la que le da la razón a todo no sirve.</p>
        <p>Escribí <a href={LIBRO} target="_blank" rel="noopener noreferrer" className="gp-enlace">«Mejor bueno por conocer»</a>. Ya no es mío: es de quien lo haga suyo.</p>
      </section>

      <section className="gp-cierre" aria-label="Contacto">
        <EnlaceBoton href="/">Contame qué necesitás</EnlaceBoton>
        <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer" className="gp-enlace gp-wa">Escribime por WhatsApp →</a>
      </section>
    </div>
  </MarcoMarca>
);

export default PersonalLanding;
